import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ec-logistics-container" }
const _hoisted_2 = { class: "dialog-footer" }

import { reactive, ref } from "vue";
	import { ElMessage } from "element-plus";
	import $http from "@/http/index";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ModifyPassWord',
  emits: ["logout"],
  setup(__props, { expose, emit: emits }) {

	
	const formRef = ref();
	const state = reactive({
		isShowDialog: false,
		form: {
			passwordNew: "",
			passwordNew2: "",
			passwordOld: ""
		}
	});

	const validatePassword = (_rule: any, value: any, callback: any) => {
		if (state.form.passwordNew != state.form.passwordNew2) {
			callback(new Error("新密码与确认新密码输入不一致"));
		} else {
			callback();
		}
	};
	const validatePassword2 = (_rule: any, value: any, callback: any) => {
		if (state.form.passwordNew && state.form.passwordNew.length < 6) {
			callback(new Error("新密码长度不能小于6位"));
		} else {
			callback();
		}
	};

	// 打開彈窗
	const openDialog = () => {
		state.isShowDialog = true;
		resetForm();
	};

	const resetForm = () => {
		state.form.passwordNew = "";
		state.form.passwordNew2 = "";
		state.form.passwordOld = "";
	};

	// 關閉彈窗
	const closeDialog = () => {
		state.isShowDialog = false;
	};

	// 取消
	const cancel = () => {
		closeDialog();
	};

	// 提交
	const submit = () => {
		formRef.value.validate(async (valid: boolean) => {
			if (!valid) {
				return;
			}
			$http({
				url: `/BaseUser/ChangePwd`,
				method: "post",
				data: JSON.stringify({
					PasswordOld: state.form.passwordOld,
					PasswordNew: state.form.passwordNew
				})
			}).then(res => {
				if (res.status && res.status == 200) {
					emits("logout");
				}
			});
		});
	};

	// 導出對像
	expose({ openDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: state.isShowDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.isShowDialog) = $event)),
      title: "修改密码",
      "close-on-click-modal": true,
      "destroy-on-close": "",
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: cancel }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode("确 定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: state.form,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 35 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24,
                  class: "mb20"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "当前密码",
                      prop: "passwordOld",
                      rules: [
								{ required: true, message: '当前密码不能为空', trigger: 'blur' }
							]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: state.form.passwordOld,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.form.passwordOld) = $event)),
                          placeholder: "当前密码",
                          class: "w100",
                          type: "password",
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24,
                  class: "mb20"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "新密码",
                      prop: "passwordNew",
                      rules: [{ validator: validatePassword2, trigger: 'blur' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: state.form.passwordNew,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.form.passwordNew) = $event)),
                          placeholder: "新密码",
                          class: "w100",
                          type: "password",
                          minl: "",
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 24,
                  lg: 24,
                  xl: 24,
                  class: "mb20"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "确认新密码",
                      prop: "passwordNew2",
                      rules: [
								{
									validator: validatePassword,
									trigger: 'blur'
								}
							]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: state.form.passwordNew2,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.form.passwordNew2) = $event)),
                          placeholder: "确认新密码",
                          class: "w100",
                          type: "password",
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})